/** 环境配置文件, 根据打包环境初始化定制的配置
 * envName: 环境名
 * document.title: 网站名称
 * company: 底部公司名
 * index_logo_CN: 中文版首页顶部logo
 * index_logo_EN: 英文版首页顶部logo
 * sp_code: 底部小程序二维码
 * wx_code: 底部微信公众号二维码
 * kefu_qq: 客服QQ
 * showKeFu: 是否展示导航条的客服和反馈
 * platformName: SSO登录显示的名称
 * showFooterInfo: 是否展示底部的公司业务和服务指南
 * showHelpCenter: 是否展示顶部的帮助中心，默认开启
 * isGLEvents: 是否属于智奥环境（可用来区别展示智奥专属提示），默认属于
 */

const getConfig = () => {
  var link = document.createElement('link')
  link.rel = 'icon'
  link.href = 'static/favicon.ico'
  switch (process.env.mode) {
    case 'taiyuan':
      document.title = '山西潇河国际会展中心'
      link.href = 'static/favicon_taiyuan.png'
      document.head.appendChild(link)
      return {
        envName: 'taiyuan',
        company: '山西潇河国际会展中心',
        index_logo_CN: 'https://admin.xiaohe.369zhan.com/backgroundimg/xiaohelogo.png',
        index_logo_EN: 'https://admin.xiaohe.369zhan.com/backgroundimg/xiaohelogo.png',
        sp_code: 'static/imgs/qr/shenzhen/sp_code.jpg',
        wx_code: 'static/imgs/qr/shenzhen/wx_code.jpg',
        kefu_qq: '3224763878',
        showKeFu: true,
        platformName: '山西潇河国际会展中心',
        showFooterInfo: false
      }
    case 'nanning':
      document.title = '广西中智兴主场服务平台'
      return {
        envName: 'nanning',
        company: '广西中智兴会展服务有限公司',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: 'static/imgs/qr/nanning/sp_code.jpg',
        wx_code: 'static/imgs/qr/nanning/wx_code.jpg',
        kefu_qq: '1570635922',
        showKeFu: true,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
    case 'qingdao':
      document.title = '智奥会展（青岛）主场服务平台'
      return {
        envName: 'qingdao',
        company: '智奥中智兴会展（青岛）有限公司',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: 'static/imgs/qr/qingdao/sp_code.jpg',
        wx_code: 'static/imgs/qr/qingdao/wx_code.jpg',
        kefu_qq: '1366749440',
        showKeFu: true,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
    case 'baima':
      document.title = '白马展馆服务平台'
      return {
        envName: 'baima',
        company: '江苏白马农业国际博览中心',
        index_logo_CN: 'static/index_logo_white_baima.png',
        index_logo_EN: 'static/index_logo_white_baima.png',
        sp_code: 'static/imgs/qr/baima/sp_code.jpg',
        wx_code: 'static/imgs/qr/baima/wx_code.jpg',
        kefu_qq: '',
        showKeFu: true,
        platformName: '智慧化展馆服务系统',
        showFooterInfo: true
      }
    case 'haikou':
      document.title = '智奥会展（海口）主场服务平台'
      return {
        envName: 'haikou',
        company: '智奥会展（海口）有限公司',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        showKeFu: true,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
    case 'fuyou':
      document.title = '深圳市富友三江主场服务平台'
      return {
        envName: 'fuyou',
        company: '深圳市富友三江国际展览有限公司',
        index_logo_CN: 'static/index_logo_fuyou.png',
        index_logo_EN: 'static/index_logo_fuyou.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '深圳市富友三江主场服务平台'
      }
    case 'wzicec':
      document.title = '温州国际会议展览中心服务平台'
      return {
        envName: 'wzicec',
        company: '温州国际会议展览中心有限公司',
        index_logo_CN: 'static/index_logo_wenzhou.png',
        index_logo_EN: 'static/index_logo_wenzhou.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        showHelpCenter: false,
        isGLEvents: false,
        platformName: '温州国际会议展览中心服务平台'
      }
    case 'nanhai':
      document.title = '南海国际会展中心服务平台'
      return {
        envName: 'nanhai',
        company: '南海国际会展中心',
        index_logo_CN: 'static/index_logo_nanhai.png',
        index_logo_EN: 'static/index_logo_nanhai.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '南海展览智慧化系统'
      }
    case 'ningbo':
      document.title = '智奥会展（宁波）主场服务平台'
      return {
        envName: 'ningbo',
        company: '智奥中智兴主场服务平台',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '智奥中智兴主场服务平台'
      }
    case 'release': {
      document.title = '智奥会展（发布）主场服务平台'
      return {
        envName: 'release',
        company: '智奥中智兴主场服务平台',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '智奥中智兴主场服务平台'
      }
    }
    case 'demo': {
      document.title = '九象主场服务平台'
      return {
        envName: 'demo',
        company: '九象主场服务平台',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '九象主场服务平台'
      }
    }
    case 'poly': {
      document.title = '保利世贸博览馆'
      return {
        envName: 'poly',
        company: '保利世贸博览馆',
        index_logo_CN: 'static/logo_bl.png',
        index_logo_EN: 'static/logo_bl.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        platformName: '保利世贸博览馆'
      }
    }
    case 'beta': {
      document.title = '保利世贸博览馆'
      return {
        envName: 'poly',
        company: '保利世贸博览馆',
        index_logo_CN: 'static/logo_bl.png',
        index_logo_EN: 'static/logo_bl.png',
        sp_code: '',
        wx_code: '',
        kefu_qq: '',
        showKeFu: false,
        platformName: '保利世贸博览馆'
      }
    }
    case 'shenzhen': {
      document.title = '智奥会展（深圳）主场服务平台'
      return {
        envName: 'shenzhen',
        company: '智奥会展（深圳）有限公司',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: 'static/imgs/qr/shenzhen/sp_code.jpg',
        wx_code: 'static/imgs/qr/shenzhen/wx_code.jpg',
        kefu_qq: '3224763878',
        showKeFu: true,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
    }
    case 'zibo': {
      document.title = '智奥会展（淄博）主场服务平台'
      return {
        envName: 'shenzhen',
        company: '智奥会展（淄博）有限公司',
        index_logo_CN: 'static/index_logo_zibo.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: 'static/imgs/qr/shenzhen/sp_code.jpg',
        wx_code: '',
        kefu_qq: '3224763878',
        showKeFu: false,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
    }
    default:
      document.title = '主场服务平台'
      return {
        envName: 'test',
        company: '智奥会展（深圳）有限公司',
        index_logo_CN: 'static/index_logo_white.png',
        index_logo_EN: 'static/index_logo_EN.png',
        sp_code: 'static/imgs/qr/shenzhen/sp_code.jpg',
        wx_code: 'static/imgs/qr/shenzhen/wx_code.jpg',
        kefu_qq: '3224763878',
        showKeFu: true,
        platformName: '智奥中智兴主场服务平台',
        showFooterInfo: true
      }
  }
}

export const envConfig = getConfig()



// WEBPACK FOOTER //
// ./src/common/global.js